import styled from "styled-components";

import { FlexContainer, FlexDiv, FlexSection } from "@/components/Atoms/Box";
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const Wrapper = styled(FlexSection)`
  padding: 64px 0;
  @media only screen and (max-width: 1079px) {
    padding: 24px 0;
  }
`;

export const Container = styled(FlexContainer)`
  @media only screen and (max-width: 1079px) {
    flex-direction: column;
  }
`;

export const LHSSection = styled(FlexDiv)`
  padding: 8px 24px;
  max-width: 552px;
  margin-right: 16px;
  @media only screen and (max-width: 1079px) {
    max-width: 100%;
    margin-right: 0;
    padding: 0px 8px;
    margin-bottom: 24px;
  }
`;

export const RHSSection = styled(FlexDiv)`
  padding: 0px 8px;
  flex-direction: column;
  flex: 1;
  @media only screen and (max-width: 1079px) {
    padding: 0;
  }
`;

export const List = styled(Typography)`
  position: relative;
  padding: 24px 24px 24px 48px;
  border-radius: 24px;
  background-color: ${theme.colorsV2.blueGray.shade_50};
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
  &:before {
    content: "";
    position: absolute;
    height: 8px;
    width: 8px;
    background-color: ${theme.colorsV2.purple.shade_600};
    top: 50%;
    left: 24px;
    border-radius: 50%;
    transform: translateY(-50%);
  }
  @media only screen and (max-width: 1079px) {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ImageBox = styled(FlexDiv)`
  height: 48px;
  width: 48px;
  align-items: center;
  justify-content: center;
  img {
    max-height: 100%;
    width: 100%;
    height: 100%;
  }
`;

export const ItemBox = styled(FlexDiv)`
  width: 100%;
  max-width: 33.33%;
  padding-right: 32px;
  flex-direction: column;
  &:last-child {
    padding-right: 0px;
  }
`;
